import styles from "./SaleTagIcon.module.scss";

type SaleTagIconProps = {
  size: "small" | "medium";
};

export const SaleTagIcon = ({ size = "small" }: SaleTagIconProps) => {
  if (size === "medium") {
    return (
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={styles.saleTag}
          d="M1.69923 1.69924L10.5381 1.69955L20.3948 11.5562L11.5559 20.395L1.69931 10.5384L1.69923 1.69924ZM6.87697 10.7776C9.03088 10.7776 10.777 9.03153 10.777 6.87762C10.777 4.72371 9.03088 2.97762 6.87697 2.97762C4.72306 2.97762 2.97697 4.72371 2.97697 6.87762C2.97697 9.03153 4.72306 10.7776 6.87697 10.7776Z"
          strokeWidth="1.5"
        />
      </svg>
    );
  } else {
    return (
      <svg
        width="15"
        height="15"
        viewBox="0 0 15 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          className={styles.saleTag}
          d="M1.07032 1.56643L6.64237 1.56663L12.9988 7.92306L7.4268 13.4951L1.07038 7.13863L1.07032 1.56643ZM4.50375 7.25016C5.74639 7.25016 6.75375 6.2428 6.75375 5.00016C6.75375 3.75752 5.74639 2.75016 4.50375 2.75016C3.26111 2.75016 2.25375 3.75752 2.25375 5.00016C2.25375 6.2428 3.26111 7.25016 4.50375 7.25016Z"
          strokeWidth="1.5"
        />
      </svg>
    );
  }
};
